<template>
    <div>
        <article class="message is-dark" v-if="isVicensCommunity">
            <div
                class="message-body has-text-centered"
                v-html="$t('Community.vicens_help_message')"
            ></div>
        </article>
        <div class="section" @paste="handlePaste">
            <div>
                <div>
                    <community-post
                        v-if="postDraft._id == 'draft' && canAddPost"
                        :model="contentModel"
                        :content="postDraft"
                        :is-creation="true"
                        class="py-4"
                        @save="createPost"
                        @addElement="openModal"
                    />
                </div>
                <div v-if="loading">
                    <div
                        v-for="i in 20"
                        :key="i"
                        class="lb-community-post is-loading my-4"
                    ></div>
                </div>
                <div
                    v-for="(post, index) in communityFeed"
                    v-else
                    :key="post._id"
                    :ref="post._id"
                >
                    <community-post-activity
                        v-if="post.type == 'ACTIVITY'"
                        :content="post"
                        class="py-4"
                    />
                    <community-post
                        v-else
                        :model="contentModel"
                        :content="post"
                        :is-creation="post._id == postDraft._id"
                        class="py-4"
                        @edit="postDraft = post"
                        @save="editPost"
                        @addElement="openModal"
                        @validate="validatePost(post, index)"
                    />
                    <!--code>{{ post }}{{ index }}</code-->
                </div>
            </div>
            <input-modal
                v-if="showInputModal"
                v-model="postDraft[contentProperty]"
                :active.sync="showInputModal"
                :component-type="componentType"
                :from-clipboard="fromClipboard"
                @input="
                    showInputModal = false;
                    fromClipboard = false;
                "
            />
        </div>
    </div>
</template>
<script>
import CommunityPost from '@/components/CommunityPost';
import InputModal from '@/components/InputModal';
import _ from 'underscore';
import { isEmptyObject } from '@/lib/helpers';
import { validatePost, exitFeed } from '@/services/API';
import CommunityPostActivity from '@/components/CommunityPostActivity';
export default {
    components: {
        CommunityPost,
        InputModal,
        CommunityPostActivity,
    },
    beforeRouteLeave(to, from, next) {
        this.exited = true;
        this.registerExit();
        next();
    },
    props: {
        hideLogin: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            postDraft: {
                _id: 'draft',
                accessLevel: 'administrator',
                owner: {},
            },
            editingPostId: null,
            fromClipboard: false,
            showInputModal: false,
            componentType: undefined,
            loading: true,
            saving: false,
        };
    },
    computed: {
        isLoggedIn() {
            return this.$store.getters.isLoggedIn;
        },
        community() {
            this.$store.commit('CLEAR_PENDING_POSTS');
            return this.$store.getters.community;
        },
        communityFeed() {
            return this.$store.getters.communityFeed;
        },
        activeUser() {
            return this.$store.getters.user;
        },
        isMember() {
            return this.community.accessLevel !== 'read';
        },
        contentModel() {
            return {
                message: { type: String },
                media: [
                    { name: 'image', type: Object },
                    { name: 'link', type: String },
                    { name: 'video', type: String },
                ],
            };
        },
        contentProperty() {
            switch (this.componentType) {
                case 'url': {
                    return 'link';
                }
                case 'singleImage': {
                    return 'image';
                }
                default:
                    return this.componentType;
            }
        },
        canAddPost() {
            if (!this.community.settings) {
                return false;
            } else {
                return (
                    (this.isMember &&
                        this.community.settings.feed_allowed_posts == 'ALL') ||
                    this.community.accessLevel == 'administrator'
                );
            }
        },
        isVicensCommunity() {
            //console.log(this.community.partner, this.community.partner.name);
            return (
                this.community.partner &&
                this.community.partner.name == 'Vicens Vives'
            );
        },
    },
    created() {
        window.addEventListener('beforeunload', this.registerExit);
    },
    beforeDestroy() {
        // this is not called on router change.
        if (false === this.exited) {
            this.registerExit();
        }
        //this.eventSource.close();
        window.removeEventListener('beforeunload', this.registerExit);
    },
    mounted() {
        if (this.isLoggedIn) {
            this.$store
                .dispatch('fetchCommunityFeed', {
                    id: this.$route.params.communityId,
                })
                .catch(() => {
                    console.error('failed to fetch community feed content');
                })
                .finally(() => {
                    this.loading = false;
                });
        }
    },
    metaInfo() {
        return {
            title: this.$t(`Community.feed`) + ' - ' + this.community.title,
            titleTemplate: '%s - Labylok',
        };
    },
    methods: {
        scrollToAnchorPoint(refName) {
            console.log('scrollToAnchorPoint feed');
            const el = this.$refs[refName];
            el && el[0].scrollIntoView({ behavior: 'smooth' });
        },
        async createPost() {
            if (this.saving === true) {
                console.log('already recived create event');
                return;
            }
            this.saving = true;

            if (
                !isEmptyObject(
                    _.omit(this.postDraft, '_id', 'accessLevel', 'owner')
                )
            ) {
                await this.$store
                    .dispatch('createPost', {
                        object: this.postDraft,
                        id: this.$route.params.communityId,
                    })
                    .catch((e) => {
                        console.error('error creatiorn', e);
                        this.saving = false;
                        return;
                    })
                    .then(() => {
                        console.log('create success!!');
                        this.postDraft = {
                            _id: 'draft',
                            accessLevel: 'administrator',
                            owner: {},
                        };
                        this.saving = false;
                    });
            } else {
                console.log('cancelling input because object is empty');
                this.saving = false;
                return;
            }
        },
        async editPost() {
            await this.$store
                .dispatch('updatePost', {
                    post: this.postDraft,
                    community: this.$route.params.communityId,
                })
                .catch((e) => {
                    console.error('error creatiorn', e);
                    return;
                })
                .finally(() => {
                    this.editingPostId = null;
                    this.postDraft = {
                        _id: 'draft',
                        accessLevel: 'administrator',
                        owner: {},
                    };
                });
        },
        async validatePost(post, index) {
            let result = await validatePost(post._id).catch();
            this.communityFeed.splice(index, 1, result.data);
        },

        handlePaste({ clipboardData }) {
            if (clipboardData.items.length) {
                _.each(clipboardData.items, (item, i) => {
                    if (item.type.indexOf('image') !== -1) {
                        this.$store.dispatch('setClipboardContent', [item]);
                        this.showInputModal = true;
                        this.componentType = 'image';
                        //this.handleImage([image.getAsFile()]);
                    }
                });
            }
        },
        openModal(e) {
            this.showInputModal = true;
            this.componentType = e;
        },
        registerExit() {
            const lastMessage = _.last(this.communityFeed);
            if (_.isEmpty(lastMessage)) {
                return;
            }
            exitFeed(lastMessage._id, this.community._id);
        },
    },
};
</script>
